export const citiesListSelector = store => store.cities.list;
export const isLoadingCitiesSelector = store => store.cities.isLoading;
export const errorCitiesList = store => store.cities.error;
